import { gql } from '@apollo/client';
import React, { FunctionComponent } from 'react';
import Avatar from '@justgiving/avatar';
import { Trans } from 'react-i18next';

import { AboutTeamFragment } from '../../../types/__generated__';
import usePageQuery, {
  UsePageQueryResult,
  buildQuery,
} from '../../hooks/usePageQuery';
import { makePhotoUrlFromAbsoluteUrl } from '../../utils/makePhotoUrl';

const FRAGMENT = buildQuery(gql`
  fragment AboutTeam on Page {
    owner {
      id
      name
      avatar
    }
  }
`);

const AboutTeam: FunctionComponent = () => {
  const result = usePageQuery<AboutTeamFragment>(FRAGMENT);

  if (!UsePageQueryResult.hasData(result)) {
    return null;
  }

  const { name, avatar } = result.data.owner!;

  return (
    <div className="jg-display-flex jg-flex-aic jg-space-mblg">
      <div className="jg-pages-aboutteam__avatar jg-space-prsm">
        <Avatar
          avatarSize="xlarge"
          picture={(avatar && makePhotoUrlFromAbsoluteUrl(avatar)) || undefined}
        />
      </div>
      <div className="jg-pages-aboutteam__content">
        <p className="jg-h5 jg-space-mbn">{name}</p>
        <p className="jg-text--small-light jg-space-mbn">
          <Trans i18nKey="team.captain">Team captain</Trans>
        </p>
      </div>
    </div>
  );
};

export default AboutTeam;
